<script>

import PayBox from "@/views/AST/Pay/Step/PayBox.vue";
import api from "@/repo/api";

export default {
    props:{
        config:Object,
        app:Object
    },
    components: {PayBox},
    data(){
        return {
            showEditModal:false,
            editLetter:''
        }
    },
    mounted() {
    },
    computed:{
        letterLines(){
            const value = this.editLetter;
            
            // 计算行数（兼容中文）
            let lines = value.split('\n');
            let totalLines = 0;
            
            for (let i = 0; i < lines.length; i++) {
                const line = lines[i];
                totalLines += Math.ceil(line.length / 41) || 1;
            }
            return totalLines;
        }
    },
    methods:{
        saveLetter(){
            if (!this.checkTextLine()) {
                return;
            }
            this.$loading.show()
            
            api.post('/ast-detect/update-single', {
                key: 'custom_letter',
                value: this.editLetter
            }, res => {
                
                this.$loading.hide()
                
                this.$message.data(res)
                
                if (res.code !== 0) return;
                
                this.showEditModal = false
                
                this.$emit('configChanged', {
                    custom_letter: this.editLetter
                })
            })
        },
        showEdit(){
            this.editLetter = this.config.custom_letter
            this.showEditModal = true;
        },
        checkTextLine() {
            
            if (this.letterLines > 27) {
                
                this.$message.error('感谢信内容不能超过27行')
                
                return false
            }
            
            return true;
        }
    }
}
</script>

<template>
    <div>
        <pay-box class="letter-pay-box">
            <table class="at-table addr-table">
                <tr>
                    <th class="va-top" style="width: 120px;">感谢信内容</th>
                    <td>
                        <pre class="letter-content">{{ config.custom_letter }}</pre>
                        <div class="letter-edit-button" @click="showEdit">在线编辑</div>
                    </td>
                </tr>
            </table>
        </pay-box>
        
        <a-modal class="transparent-modal" width="600px" v-model="showEditModal">
            <div class="letter-content-edit">
<!--                <img src="https://static.ycsd.work/col/letter-preview.png">-->
                <img src="https://static.ycsd.work/col/letter-edit-v3.png">
                
                <div class="textarea-box">
                    <textarea v-model="editLetter"></textarea>
                </div>
                <div class="content-tips text-warning">感谢信内容不能超过27行,当前已输入{{ letterLines }}行</div>
                
                <div class="app-name">{{ app.nickname }}</div>
            </div>
            <div slot="footer" class="edit-footer">
                <div class="flex flex-space-between">
                    <div>
                    </div>
                    <div>
                        <button class="btn" @click="saveLetter">保存修改</button>
                        <button class="btn btn-white" @click="showEditModal = false">取消</button>
                    </div>
                </div>
            </div>
        </a-modal>
        
    </div>
</template>

<style scoped lang="less">

.va-top{
    vertical-align: top;
}

.letter-pay-box{
    margin-top: -24px;
    border-top: 0;
}

.letter-content{
    white-space: pre-wrap;
    background: #FAFAFA;
    padding: 16px;
    max-width: 836px;
    font-weight: 400;
    font-size: 12px;
    color: #333333;
    line-height: 20px;
}

.letter-edit-button{
    width: 100px;
    height: 32px;
    border: 1px solid #333333;
    line-height: 32px;
    text-align: left;
    cursor: pointer;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    padding-left: 32px;
    background-image: url("/assets/images/contract-icon-edit.png");
    background-size: 18px;
    background-repeat: no-repeat;
    background-position: 11px 7px;
    
}


.addr-table {
    width: 100%;
    border: none;
    
    th {
        background-color: transparent;
        width: 120px;
        font-size: 14px;
        color: #333333;
        line-height: 16px;
        font-weight: normal;
        
        text-align: right;
    }
    
    td {
        text-align: left;
    }
    
    tr, th, td {
        border: none;
    }
}
.letter-content-edit{
    position: relative;
    img{
        width: 600px;
    }
    
    .app-name{
        font-size: 16px;
        position: absolute;
        bottom:115px;
        right: 45px;
    }
}
.content-tips{
    position: absolute;
    top: 690px;
    left: 45px;
    font-size: 12px;
    color: #333333;
}
.textarea-box{
    position: absolute;
    width: 510px;
    height: 533px;
    top: 147px;
    left: 45px;
    
    textarea{
        width: 100%;
        height: 100%;
        max-height: 533px;
        overflow: hidden;
        line-height: 1.61;
        background-color: transparent;
        outline: none;
        padding: 5px;
        font-size: 12px;
        border: 2px dashed #EEEEEE;
        resize: none;
    }
}

.edit-footer{
    position: absolute;
    bottom:30px;
    left: 0;
    width: 100%;
    padding-left: 45px;
    padding-right: 45px;
}

</style>